import './feed.scss';

import Masonry from 'masonry-layout';
import { Loader } from '../../services/loader';
import { createElementFromHTML } from '../../utilities/js/helper.js';
class Feed {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-feed',
            loaderAttr: 'data-feed-loader',
            handleAttr: 'data-feed-loaderhandle',
            loading: null,
            onSubmitted: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.$feed = element;

        this.$feedLoader = this.$feed.querySelector('[' + this.settings.loaderAttr + ']');
        this.$feedLoaderHandle = this.$feed.querySelector('[' + this.settings.handleAttr + ']');
        this.$feedResults = this.$feed.querySelector('[' + this.settings.initAttr + '="results"]');
        this.$feedForm = this.$feed.querySelector('[' + this.settings.initAttr + '="form"]');
    }

    initialize () {
        // Init loader
        if (this.$feedLoader) {
            this.initLoader(this.$feedLoader);
        }

        // Init masonry
        setTimeout(() => {
            this.initMasonry(this.$feedResults);
        }, 500);
    }

    initLoader ($loader) {
        this.loader = new Loader($loader, {
            loading: this.settings.loading,
            initAttr: 'data-feed-loader',
            handleAttr: 'data-feed-loaderhandle',
            external: true,
            onSubmitted: (results) => {
                if (typeof results !== 'undefined' && results !== '') {
                    const resultsJSON = JSON.parse(results);

                    if (typeof resultsJSON === 'object' && typeof resultsJSON.nextPageUrl !== 'undefined' && typeof resultsJSON.template !== 'undefined') {
                        const nextPageUrl = resultsJSON.nextPageUrl;
                        const $newItems = createElementFromHTML(resultsJSON.template);

                        if (nextPageUrl !== null) {
                            this.$feedLoaderHandle.href = nextPageUrl;
                        } else {
                            this.$feedLoader.classList.add('is--hidden');
                        }

                        const $newContent = document.createElement('div');

                        $newItems.forEach(item => {
                            $newContent.appendChild(item);
                        });

                        if (typeof this.settings.onSubmitted === 'function') {
                            this.settings.onSubmitted($newContent);
                        }

                        $newItems.forEach(item => {
                            this.$feedResults.insertBefore(item, this.$feedLoader);
                            this.masonry.appended(item);
                            setTimeout(() => {
                                this.masonry.layout();
                                this.masonry.reloadItems();
                            }, 150);
                        });

                        setTimeout(() => {
                            this.$feedResults.append(this.$feedLoader);
                        }, 150);
                    }
                }
            }
        });

        this.loader.initialize();
    }

    initMasonry ($obj) {
        this.masonry = new Masonry($obj, {
            itemSelector: '[' + this.settings.initAttr + '="result"]',
            columnWidth: '[' + this.settings.initAttr + '="result"]',
            percentPosition: true
        });

        // this.$feed.data('feed', this.masonry);  // Funktionalität prüfen
    }
}

export { Feed };
